import { useMemo, useState, useEffect } from 'react'
import TeacherService from '../../services/teacher-service.js'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'

import TableContainer from '@mui/material/TableContainer'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import Spinner from '../../components/Spinner/index.js'
import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'

const Teacher = () => {
  const [students, setStudents] = useState([])

  useEffect(() => {
    TeacherService.students().then(response => {
      setStudents(response)
    })
  }, [])

  const mappedStudents = useMemo(() => {
    return students?.map((student, index) => (
      <TableRow key={index}>
        <TableCell
          className={`text-center !text-over-primary-background ${
            index === students.length - 1 && '!border-none'
          }`}
        >
          {student.name}
        </TableCell>
        <TableCell
          className={`text-center !text-over-primary-background ${
            index === students.length - 1 && '!border-none'
          }`}
        >
          {student.email}
        </TableCell>
        <TableCell
          className={`text-center !text-over-primary-background ${
            index === students.length - 1 && '!border-none'
          }`}
        >
          {student.answers_24h}
        </TableCell>
        <TableCell
          className={`text-center !text-over-primary-background ${
            index === students.length - 1 && '!border-none'
          }`}
        >
          {student.answers_7d}
        </TableCell>
        <TableCell
          className={`text-center !text-over-primary-background ${
            index === students.length - 1 && '!border-none'
          }`}
        >
          {student.answers_30d}
        </TableCell>
        <TableCell
          className={`text-center !text-over-primary-background ${
            index === students.length - 1 && '!border-none'
          }`}
        >
          {student.amounts.reduce((sum, amount) => sum + amount / 100, 0)} RON
        </TableCell>
      </TableRow>
    ))
  }, [students])

  return (
    <DashboardLayout className="absolute">
      {students !== null ? (
        <div>
          <div className="py-5 text-over-primary-background">
            Puteți vedea mai jos lista tuturor studentilor care și-au cumpărat
            abonament pe platformă cu voucherul dumneavoastră
          </div>
          <TableContainer
            className="!bg-container-background !shadow-none"
            component={Paper}
          >
            <Table>
              <TableRow>
                <TableCell className="text-bold text-center !text-over-primary-background !border-black">
                  Nume Elev
                </TableCell>
                <TableCell className="text-bold text-center !text-over-primary-background !border-black">
                  Email
                </TableCell>
                <TableCell className="text-bold text-center !text-over-primary-background !border-black">
                  Grile Rezolvate <br />
                  (24h)
                </TableCell>
                <TableCell className="text-bold text-center !text-over-primary-background !border-black">
                  Grile Rezolvate <br />
                  (7 zile)
                </TableCell>
                <TableCell className="text-bold text-center !text-over-primary-background !border-black">
                  Grile Rezolvate <br />
                  (30 zile)
                </TableCell>
                <TableCell className="text-bold text-center !text-over-primary-background !border-black">
                  Sumă încasată
                </TableCell>
              </TableRow>
              <TableBody>{mappedStudents}</TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <Spinner />
      )}
    </DashboardLayout>
  )
}
export default Teacher
